import { Injectable, NgZone } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { Router } from '@angular/router';
import {HttpClient, HttpParams} from '@angular/common/http';
import { Token } from '@angular/compiler';
import { CacheService } from '../cache.service';
import { NS_Enums } from '../shared/namespaces';
import { get } from 'lodash-es';
import { isLocalStorageAvailable } from '../shared/helpers/helpers';
import { ProductFruitService } from '../services/productFruit/product-fruit.service';

export const USER_STORAGE_KEY = NS_Enums.cacheKeysEnum.user;

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  userData: any; // Save logged in user data
  private _authToken: Token;

  public globalAuthInitialized: boolean = false;

  constructor(
    public afs: AngularFirestore,   // Inject Firestore service
    public afAuth: AngularFireAuth, // Inject Firebase auth service
    public router: Router,
    public ngZone: NgZone, // NgZone service to remove outside scope warning
    public http: HttpClient,
    private cacheService: CacheService,
    private productFruitService: ProductFruitService
  ) {
    /* Saving user data in localstorage when
    logged in and setting up null when logged out */
    this.afAuth.authState.subscribe(user => {
      if (user) {
        this.globalAuthInitialized = true;
        this.userData = user;
        if (isLocalStorageAvailable()) {
          localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(this.userData));
        }
      } else {
        if (isLocalStorageAvailable()) {
          localStorage.removeItem(USER_STORAGE_KEY);
        }
        if(this.globalAuthInitialized){
          this.afAuth.signOut().then(() => {
            this.cacheService.clear();
            this.router.navigate(['/login']);
            window['fcWidget']?.destroy();
          });
        }
      }
    });
  }
  getUser(){
    return this.userData
  }

  // Sign in with email/password
  SignIn(email, password) {
    return this.afAuth.signInWithEmailAndPassword(email, password)
  }

  // Sign up with email/password
  SignUp(email, password) {
    return this.afAuth.createUserWithEmailAndPassword(email, password)
      .then((result) => {
        /* Call the SendVerificaitonMail() function when new user sign
        up and returns promise */
        this.SendVerificationMail();
       // this.SetUserData(result.user);
      }).catch((error) => {
        window.alert(error.message);
      });
  }

  // Send email verfificaiton when new user sign up
  SendVerificationMail() {
    return this.afAuth.currentUser.then(u => u?.sendEmailVerification())
      .then(() => {
        this.router.navigate(['verify-email-address']);
      });
  }

  // Reset Forggot password
  ForgotPassword(passwordResetEmail) {
    return this.afAuth.sendPasswordResetEmail(passwordResetEmail)
      .then(() => {
        window.alert('Password reset email sent, check your inbox.');
      }).catch((error) => {
        window.alert(error);
      });
  }

  // Returns true when user is looged in and email is verified
  get isLoggedIn(): boolean {
    if (!isLocalStorageAvailable()) return false;
    const user = JSON.parse(localStorage.getItem(USER_STORAGE_KEY));
    return user !== null && user.emailVerified !== false;
  }

  // Sign out
  SignOut() {
    return this.afAuth.signOut().then(() => {
      if (isLocalStorageAvailable()) {
        localStorage.removeItem(USER_STORAGE_KEY);
      }
      this.router.navigate(['sign-in']);
    });
  }

  get authToken() {
    const saras_auth_key = this.cacheService.getObject<Token>(NS_Enums.cacheKeysEnum.saras_auth_key);
    return get(saras_auth_key, 'token');
  }
}
